import { render } from "./NotFoundPage.vue?vue&type=template&id=5e095d71"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=5e095d71&lang=css"
script.render = render

export default script